import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert, Snackbar } from "@mui/material";
import { createCustomer } from "../api/customerApi";

const CreateCustomerPage: React.FC = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    dispensary_name: "",
    phone: "",
    shipping_address: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [tempPassword, setTempPassword] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await createCustomer(form);
      setTempPassword(response.tempPassword || null);
      setForm({
        name: "",
        email: "",
        password: "",
        dispensary_name: "",
        phone: "",
        shipping_address: "",
      });
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error creating customer:", error);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "0 auto", padding: 4 }}>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        Create New Customer
      </Typography>
      <TextField label="Name" name="name" value={form.name} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth margin="normal" />
      <TextField
        label="Password (Optional)"
        name="password"
        type="password"
        value={form.password}
        onChange={handleChange}
        helperText="Leave blank to generate a temporary password."
        fullWidth
        margin="normal"
      />
      <TextField
        label="Dispensary Name"
        name="dispensary_name"
        value={form.dispensary_name}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth margin="normal" />
      <TextField
        label="Shipping Address"
        name="shipping_address"
        value={form.shipping_address}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <Button variant="contained" onClick={handleSubmit} fullWidth sx={{ marginTop: 2 }}>
        Create Customer
      </Button>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <Alert severity="success">
          Customer created successfully.
          {tempPassword && ` Temporary password: ${tempPassword}`}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateCustomerPage;
